/** Credit row → linked USD wallet transaction id. */
export function getUsdSourceIdFromCreditRow(row) {
    var _a, _b, _c;
    if (!row)
        return null;
    const rt = String((_b = (_a = row.referenceType) !== null && _a !== void 0 ? _a : row.reference_type) !== null && _b !== void 0 ? _b : '').trim();
    const rid = (_c = row.referenceId) !== null && _c !== void 0 ? _c : row.reference_id;
    const linked = row.linkedUsdTransactionId;
    if (linked != null && String(linked).trim() !== '')
        return String(linked).trim();
    if (rt === 'usd_wallet_transaction' && rid != null && String(rid).trim() !== '') {
        return String(rid).trim();
    }
    return null;
}
/** USD row → linked credit wallet transaction id (balance_to_credits flow). */
export function getCreditSourceIdFromUsdRow(row) {
    var _a, _b, _c;
    if (!row)
        return null;
    const meta = row.metadata;
    if (!meta || typeof meta !== 'object')
        return null;
    const raw = (_c = (_b = (_a = meta.wallet_transaction_id_payee) !== null && _a !== void 0 ? _a : meta.walletTransactionIdPayee) !== null && _b !== void 0 ? _b : meta.wallet_transaction_id) !== null && _c !== void 0 ? _c : meta.walletTransactionId;
    if (raw == null || String(raw).trim() === '')
        return null;
    return String(raw).trim();
}
/** USD settlement row → original USD withdrawal id. */
export function getSourceUsdIdFromSettlementRow(row) {
    var _a, _b, _c;
    if (!row)
        return null;
    const rt = String((_b = (_a = row.referenceType) !== null && _a !== void 0 ? _a : row.reference_type) !== null && _b !== void 0 ? _b : '').trim();
    if (rt !== 'balance_to_credits_settlement')
        return null;
    const meta = row.metadata;
    if (!meta || typeof meta !== 'object')
        return null;
    const raw = (_c = meta.source_usd_wallet_txn_id) !== null && _c !== void 0 ? _c : meta.sourceUsdWalletTxnId;
    if (raw == null || String(raw).trim() === '')
        return null;
    return String(raw).trim();
}
